// extracted by mini-css-extract-plugin
module.exports = {"section":"section-module__section___-OWoe"};